import { Dimensions, Weight } from 'models/product';
import { HelmetIcon } from 'i/measurement/helmet-icon';
import { GogglesIcon } from 'i/measurement/goggles-icon';
import { BootsIcon } from 'i/measurement/boot-icon';
import { GearIcon } from 'i/measurement/gear-icon';

const CategoryMeasurementSection = ({
  category,
  onSelect,
  weight,
  dimensions,
}: {
  category: string;
  weight: Weight;
  dimensions: Dimensions;
  onSelect: (measurements: { weight: Weight; dimensions: Dimensions }) => void;
}) => {
  const formatWeight = (weight?: number) => {
    if (!weight) return 0;

    if (weight < 16) return weight + ' oz';

    return (weight / 16).toFixed(2) + ' lbs';
  };

  const formattedWeight = `${formatWeight(weight.value)} 
  (${dimensions.length} x ${dimensions.width} x ${dimensions.height} in)`

  return (
    <button
      className="flex cursor-pointer items-center p-8 hover:bg-brand-darker-white border-t border-[#d9d9d9]"
      onClick={() => onSelect({ weight: weight, dimensions: dimensions })}
      type='button'
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-x-4">
          {/* TODO: create a dictionary for group the icons */}
          {category.toLowerCase().includes('gear') && (
            <GearIcon className="h-20 w-20" />
          )}
          {category.toLowerCase().includes('helmet') && (
            <HelmetIcon className="h-20 w-20" />
          )}
          {category.toLowerCase().includes('goggles') && (
            <GogglesIcon className="h-20 w-20" />
          )}
          {category.toLowerCase().includes('boots') && (
            <BootsIcon className="h-20 w-20" />
          )}
          <h5 className="text-body-sm font-semibold">{category}</h5>
        </div>
        <p className="text-body-sm">{formattedWeight}</p>
      </div>
    </button>
  );
};

export default CategoryMeasurementSection;
